import { updateEmployeeTaxRegime } from "../../infrastructure/repository/employees-repository";

export default async function changeEmployeesTaxRegime({
  companyId,
  employeeIds,
  taxRegime,
}: {
  companyId: string;
  employeeIds: string[];
  taxRegime: string;
}): Promise<void> {
  await updateEmployeeTaxRegime({ companyId, employeeIds, taxRegime });
}
